import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const savedLanguage = localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: 'en',
    debug: false,
    defaultNS: 'common',
    ns: ['common'],
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;